import React, { useEffect, useRef, useState } from 'react';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

/**
 * Renders the official "Sign in with Google" button and calls onSuccess with the ID token (JWT).
 * Requires REACT_APP_GOOGLE_CLIENT_ID and the GSI script in index.html.
 */
const GoogleSignInButton = ({ onSuccess, onError, disabled, className = '', text = 'signin_with' }) => {
  const containerRef = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!GOOGLE_CLIENT_ID) return;

    const init = () => {
      if (!window.google?.accounts?.id || !containerRef.current) return;
      try {
        window.google.accounts.id.initialize({
          client_id: GOOGLE_CLIENT_ID,
          callback: (response) => {
            if (response?.credential && onSuccess) {
              onSuccess(response.credential);
            } else if (onError) {
              onError(new Error('No credential returned'));
            }
          },
          auto_select: false
        });
        window.google.accounts.id.renderButton(containerRef.current, {
          type: 'standard',
          theme: 'outline',
          size: 'large',
          text,
          width: containerRef.current?.offsetWidth || 320,
          shape: 'rectangular'
        });
        setReady(true);
      } catch (e) {
        if (onError) onError(e);
      }
    };

    if (window.google?.accounts?.id) {
      init();
      return;
    }
    const t = setInterval(() => {
      if (window.google?.accounts?.id) {
        clearInterval(t);
        init();
      }
    }, 100);
    return () => clearInterval(t);
  }, [GOOGLE_CLIENT_ID, onSuccess, onError, text]);

  if (!GOOGLE_CLIENT_ID) return null;

  return (
    <div
      className={className}
      style={{ minHeight: 44, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <div
        ref={containerRef}
        style={{ opacity: ready && !disabled ? 1 : 0.5, pointerEvents: disabled ? 'none' : 'auto' }}
      />
    </div>
  );
};

export default GoogleSignInButton;
